import * as tslib_1 from "tslib";
import { updateUserOptions, updateUserConfiguration } from 'owa-options-core';
import toggleDarkModeThemeAction from '../actions/toggleDarkModeTheme';
import { orchestrator } from 'satcheljs';
import previewDarkModeTheme from './previewDarkModeTheme';
export default function commitDarkModeTheme(isDarkModeTheme) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    previewDarkModeTheme(isDarkModeTheme);
                    updateUserOptions({ IsDarkModeTheme: isDarkModeTheme });
                    return [4 /*yield*/, updateUserConfiguration([
                            {
                                propertyName: 'isDarkModeTheme',
                                propertyType: 'Boolean',
                                propertyValue: "" + isDarkModeTheme,
                            },
                        ])];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    });
}
orchestrator(toggleDarkModeThemeAction, function (msg) { return commitDarkModeTheme(msg.isDarkModeEnabled); });
//# sourceMappingURL=commitDarkModeTheme.js.map